module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="team-builder-info-bar">\n	';
 if(is_show_banner){ 
__p+='\n		<div class="assistant-coach-bar">\n			<div class="assistant-coach-bar-content">\n				<i class="icon ion-ios-checkmark-outline"></i>\n				<span class="text">'+
((__t=( trial_coach_text ))==null?'':__t)+
'</span>\n				<a href="/help/coach" class="btn more js-more">FIND OUT MORE</a>\n				<a href="/account/coach-settings" class="btn sign-up">SIGN UP TODAY</a>\n			</div>\n			<a class="assistant-coach-bar-close js-assistant-coach-bar-close">\n				<i class="ion-android-close"></i>\n			</a>\n		</div>\n	';
 } 
__p+='\n	<figure>\n		<img src="'+
((__t=( avatar_url ))==null?'':_.escape(__t))+
'" alt="">\n	</figure>\n	';
 if(name){ 
__p+='\n		<h3>'+
((__t=( name ))==null?'':_.escape(__t))+
' ('+
((__t=( team_size ))==null?'':_.escape(__t))+
' / '+
((__t=( max_team_size ))==null?'':_.escape(__t))+
')</h3>\n		<div class="social-sharing-box">\n			<a class="share share-fb js-share-fb js-sharing" data-type="fb">\n				<i class="icon ion-social-facebook"></i>\n			</a>\n			<a class="share share-tw js-share-tw js-sharing" data-type="tw">\n				<img class="twitter-x" src="/assets/images/footer/tw.png" alt="Twitter">\n			</a>\n\n		</div>\n		<div class="selects-box">\n			<select name="additional_stats" class="js-additional-stats">\n				';
 _.each(stats, function(item){ 
__p+='\n					<option value="'+
((__t=( item.val ))==null?'':_.escape(__t))+
'" '+
((__t=( selected_stats === item.val ? 'selected' : '' ))==null?'':_.escape(__t))+
'>\n						'+
((__t=( item.key ))==null?'':_.escape(__t))+
'\n					</option>\n				';
 }) 
__p+='\n			</select>\n		</div>\n	';
 } 
__p+='\n</div>';
}
return __p;
};
